module.exports = __webpack_public_path__ + "img/CG.aa9109a4.svg";